import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ChatLazy = React.lazy(
	() => import(/* webpackChunkName : 'MessagingChat' */ './Chat')
);

export default () => [
	{
		path: ':chatId',
		element: <AsyncLoading component={<ChatLazy />} />,
	},
];
